// extracted by mini-css-extract-plugin
export default {"wrapper":"footerEn_wrapper__z6l4x","header":"footerEn_header__RQjIh","sns":"footerEn_sns__KBjk7","desc":"footerEn_desc__6sZk1"};